import React from 'react';
import { IconButton  } from "@mui/material";

export const NavigationIcons = ({ item, selectedButton, handleButtonClick, documentID }) => {
  return (
    <IconButton
      key={item.id}
      aria-label={item.name}
      onClick={() => handleButtonClick(item.id)}
      disabled={!documentID && !["General", "Usuarios", "Clipping", "Complemento DOC", "Documentos"].includes(item.name)}
      style={{
        marginBottom: "15px",
        backgroundColor:
          selectedButton === item.id ? "rgba(0, 0, 0, 0.25)" : "transparent",
      }}
    >
      {item.icon}
    </IconButton>
  )
}
